import { SVGProps, useMemo } from 'react';

import { useTheme } from '@/features/theme-switch';

const Arrow2 = (props: SVGProps<SVGSVGElement>) => {
  const { darkTheme } = useTheme();

  const color = useMemo(() => (darkTheme ? '#A0A8AA' : '#A0A8AA'), [darkTheme]);

  return (
    // <svg
    //   width={ 20 }
    //   height={ 20 }
    //   fill="none"
    //   viewBox="0 0 20 20"
    //   stroke={ color }
    //   { ...props }
    // >
    //   <path
    //     stroke="current"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //     strokeWidth={ 1.5 }
    //     d="M11.667 5.833 7.5 10l4.167 4.167"
    //   />
    // </svg>

    <svg width={12} height={44} viewBox="0 0 12 44" fill={color} {...props}>
      <path
        d="M1.84 22.256V10.24H2.976V21.12H6.816C6.32 20.56 5.792 19.696 5.28 18.576H6.192C7.312 19.872 8.496 20.848 9.712 21.456V21.92C8.496 22.528 7.312 23.488 6.192 24.8H5.28C5.792 23.68 6.32 22.816 6.816 22.256H1.84Z"
        fill="current"
      />
    </svg>
  );
};
export default Arrow2;
